var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Action Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.60003 2.43338L8.20002 0.833374L11 3.63338L9.40001 5.23336M6.60003 2.43338L1.16568 7.86771C1.0596 7.97377 1 8.11768 1 8.2677V10.8334H3.56569C3.71572 10.8334 3.8596 10.7738 3.96569 10.6677L9.40001 5.23336M6.60003 2.43338L9.40001 5.23336",
    stroke: "#4E4FA9",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfEditIcon);
export default __webpack_public_path__ + "static/media/pdf-edit-icon.4f1a8a6f6bdf43cb327ef31df8f496d5.svg";
export { ForwardRef as ReactComponent };